


















import { Component, Vue, Model } from "vue-property-decorator";

@Component
class UserSelect extends Vue {
  @Model("update") user;

  searching = false;

  id = "";

  async handleSearch() {
    if (!this.id) return;
    this.searching = true;
    await this.requestSearchUser();
    this.searching = false;
  }

  async requestSearchUser() {
    try {
      const user = await this.$api.wallet.mixin.searchUser(this.id);
      this.$emit("update", user);
      this.$emit("searched");
    } catch (error) {
      this.$emit("error");
    }
  }
}
export default UserSelect;
